import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { Fragment, useContext, useState } from "react";
import {
  FiEdit,
  FiTrash,
  FiUser,
} from "react-icons/fi";
import { Credential, CredentialType } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import flex from "../../../styles/flex";
import styles from "./styles";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const CredentialListItem: React.FunctionComponent<{
  credential: Credential;
  onEditCredential: (user: Credential) => void;
  onDelete?: () => void;
}> = (props) => {
  const [credential] = useState(props.credential);

  const session = useContext(SessionContext);
  const { t } = useTranslation();

  const theme = useTheme();
  const isLargeDevice = useMediaQuery(theme.breakpoints.up("md"));

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  if (session.current.site == null) {
    return <Fragment />;
  }


  return (
    <Fragment>
      <Dialog open={showDeleteConfirmation}>
        <DialogTitle>{t("admin.credentials.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("admin.credentials.message")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowDeleteConfirmation(false);
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            onClick={() => {
              setShowDeleteConfirmation(false);
              if (props.onDelete != null) {
                props.onDelete();
              }
            }}
          >
            <b>{t("general.delete")}</b>
          </Button>
        </DialogActions>
      </Dialog>
      <div
        style={{ ...styles.bookingListItem, opacity: credential.active == true ? 1 : 0.5 }}
      >
        <div
          style={{
            ...flex.flexRows,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={flex.flexAuto}>
            <div>
              <IconButton disabled={true}>
                <FiUser />
              </IconButton>
            </div>
          </div>
          <div style={{ ...flex.flexFill, textAlign: "left" }}>
            <div>
              <b>
                {credential.firstName} {credential.lastName}
              </b>
            </div>
            <div>
              {credential.type == CredentialType.systemAdmin && (<b style={{ color: "red" }}>{t("users.systemAdmin")}</b>)}
              {credential.type == CredentialType.service && (<b style={{ color: "blue" }}>{t("admin.service")}</b>)}
              {credential.type == CredentialType.user && (<b style={{ color: "green" }}>{t("admin.user")}</b>)}
            </div>
          </div>

          {isLargeDevice == true && (
            <div style={{ ...flex.flexFill, textAlign: "left" }}>
              <div>{credential.userName}</div>
              <div>{credential.email}</div>
            </div>
          )}

          <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>

            <IconButton
              onClick={() => {
                props.onEditCredential(credential);
              }}
            >
              <FiEdit />
            </IconButton>
            <div>
              <small>{t("general.edit")}</small>
            </div>

          </div>

          <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
            <IconButton
              disabled={props.onDelete == null}
              onClick={() => {
                setShowDeleteConfirmation(true);
              }}
            >
              <FiTrash />
            </IconButton>
            <div>
              <small>{t("general.delete")}</small>
            </div>
          </div>

        </div>
      </div>
    </Fragment>
  );
};

CredentialListItem.propTypes = {
  credential: propTypes.any.isRequired,
  onEditCredential: propTypes.func.isRequired,
  onDelete: propTypes.func
};

export default CredentialListItem;
